/* Decorative only: never reads or changes customers, products or cart state. */
(() => {
  const active = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function mount(root) {
    root.querySelectorAll('[data-sw-snow]').forEach(hero => {
      if (active.has(hero)) return;
      const snow = hero.querySelector('.sw-snow');
      if (!snow) return;
      for (let i = 0; i < 22; i++) {
        const flake = document.createElement('i');
        flake.style.left = `${(i * 47) % 100}%`;
        flake.style.setProperty('--duration', `${12 + (i % 9)}s`);
        flake.style.setProperty('--delay', `${-(i * 1.7)}s`);
        snow.append(flake);
      }
      const emblem = document.createElement('img');
      emblem.src = snow.dataset.emblem;
      emblem.alt = '';
      snow.append(emblem);
      let inView = true;
      const pause = () => snow.classList.toggle('is-paused', document.hidden || !inView || reduced.matches);
      const resize = new ResizeObserver(([entry]) => snow.style.setProperty('--sw-travel', `${entry.contentRect.height + 45}px`));
      resize.observe(snow);
      const observer = new IntersectionObserver(([entry]) => { inView = entry.isIntersecting; pause(); });
      observer.observe(hero);
      document.addEventListener('visibilitychange', pause);
      reduced.addEventListener('change', pause);
      pause();
      active.set(hero, () => { resize.disconnect(); observer.disconnect(); document.removeEventListener('visibilitychange', pause); reduced.removeEventListener('change', pause); snow.replaceChildren(); });
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    active.forEach((cleanup, hero) => { if (event.target.contains(hero)) { cleanup(); active.delete(hero); } });
  });
})();
